if (!customElements.get('farm-floating-atc')) {
  customElements.define(
    'farm-floating-atc',
    class FarmFloatingAtc extends HTMLElement {
      connectedCallback() {
        this.section = document.querySelector(this.dataset.sectionSelector);
        this.lastScrollY = window.scrollY;
        this.isCompact = false;
        this.ticking = false;
        this.onScroll = this.onScroll.bind(this);
        this.update = this.update.bind(this);
        this.mobileQuery = window.matchMedia('(max-width: 989px)');

        if (window.Shopify && Shopify.designMode) {
          this.reveal(false);
          this.syncTop(false);
          return;
        }

        if (!this.section) return;

        this.bindHeaderObserver();
        this.update();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.headerObserver?.disconnect();
      }

      bindHeaderObserver() {
        const sectionHeader = document.querySelector('.section-header');
        if (!sectionHeader || typeof MutationObserver === 'undefined') return;

        this.headerObserver = new MutationObserver(() => this.syncObscured());
        this.headerObserver.observe(sectionHeader, {
          attributes: true,
          attributeFilter: ['class'],
        });
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.update();
          this.ticking = false;
        });
      }

      isMobilePanelOpen() {
        if (!this.mobileQuery.matches) return false;
        const sectionHeader = document.querySelector('.section-header');
        return Boolean(
          sectionHeader?.classList.contains('menu-open') || sectionHeader?.classList.contains('cart-open')
        );
      }

      update() {
        if (!this.section) return;

        const sectionBottom = this.section.getBoundingClientRect().bottom;
        const scrolledPast = sectionBottom <= 0;
        const scrollY = window.scrollY;
        const scrollDelta = scrollY - this.lastScrollY;

        if (Math.abs(scrollDelta) > 2) {
          this.isCompact = scrollDelta > 0;
          this.lastScrollY = scrollY;
        }

        if (!scrolledPast) {
          this.hide();
          return;
        }

        this.reveal(this.isCompact);
        this.syncTop(this.isCompact);
        this.syncObscured();
      }

      syncObscured() {
        const obscured = this.isMobilePanelOpen();
        this.classList.toggle('is-obscured', obscured);
        if (obscured) {
          this.setAttribute('aria-hidden', 'true');
        } else if (this.classList.contains('is-visible')) {
          this.setAttribute('aria-hidden', 'false');
        }
      }

      syncTop(compact) {
        if (!this.mobileQuery.matches) {
          this.style.removeProperty('--farm-floating-top');
          return;
        }

        if (compact) {
          this.style.setProperty('--farm-floating-top', '1rem');
          return;
        }

        const headerBar = document.querySelector('.section-header .header-wrapper');
        if (!headerBar) {
          this.style.setProperty('--farm-floating-top', '1rem');
          return;
        }

        const sectionHeader = document.querySelector('.section-header');
        const headerHidden = sectionHeader?.classList.contains('shopify-section-header-hidden');
        if (headerHidden) {
          this.style.setProperty('--farm-floating-top', '1rem');
          return;
        }

        const bottom = Math.max(0, headerBar.getBoundingClientRect().bottom);
        this.style.setProperty('--farm-floating-top', `calc(${bottom}px + 1rem)`);
      }

      reveal(compact) {
        this.classList.add('is-visible');
        this.classList.toggle('is-compact', Boolean(compact));
        if (!this.classList.contains('is-obscured')) {
          this.setAttribute('aria-hidden', 'false');
        }
      }

      hide() {
        this.classList.remove('is-visible', 'is-compact', 'is-obscured');
        this.isCompact = false;
        this.setAttribute('aria-hidden', 'true');
        this.style.removeProperty('--farm-floating-top');
      }
    }
  );
}
